module.exports = __webpack_public_path__ + "img/form-tri2.7cc443b0.svg";